// ================================================================
// 🏷️ ACTIVE FILTERS TAGS - Tags de Filtros Ativos
// ================================================================

import React from 'react';
import { Badge } from 'react-bootstrap';
import { Icon } from '@iconify/react';

/**
 * 🏷️ ActiveFiltersTags - Componente para exibir filtros ativos como tags
 * 
 * @param {Object} props
 * @param {Object} props.filters - Objeto com os filtros ativos
 * @param {Function} props.onRemoveFilter - Callback ao remover um filtro (key)
 * @param {Array} props.availableUsers - Lista de usuários disponíveis (para exibir nome)
 */
const ActiveFiltersTags = ({ filters = {}, onRemoveFilter, availableUsers = [] }) => {
  if (!filters || Object.keys(filters).length === 0) {
    return null;
  }

  const getFilterLabel = (key, value) => {
    switch (key) {
      case 'user_type':
        const typeLabels = {
          seller: 'Vendedor',
          direct_affiliate: 'Afiliado Direto',
          indirect_affiliate: 'Afiliado Indireto'
        };
        return typeLabels[value] || value;
      
      case 'user_id':
        const user = availableUsers.find(u => u.id === parseInt(value));
        return user ? user.name : `Usuário #${value}`;
      
      case 'product_id':
        return `Produto #${value}`;
      
      case 'payment_method':
        const methodLabels = {
          credit_card: 'Cartão de Crédito',
          pix: 'PIX',
          boleto: 'Boleto'
        };
        return methodLabels[value] || value;
      
      case 'sale_status':
        const statusLabels = {
          paid: 'Pago',
          pending: 'Pendente',
          cancelled: 'Cancelado',
          refunded: 'Reembolsado'
        };
        return statusLabels[value] || value;
      
      case 'region':
        return `Região: ${value}`;
      
      default:
        return value;
    }
  };

  const getFilterColor = (key) => {
    switch (key) {
      case 'user_type':
        return 'primary';
      case 'user_id':
        return 'success';
      case 'product_id':
        return 'info';
      case 'payment_method':
        return 'warning';
      case 'sale_status':
        return 'secondary';
      case 'region':
        return 'dark';
      default:
        return 'primary';
    }
  };

  // Filtrar apenas os filtros que têm valor e não são objetos complexos
  const activeFilters = Object.entries(filters).filter(([key, value]) => {
    if (!value && value !== 0) return false;
    if (key === 'customDateRange' && typeof value === 'object') return false;
    // Mostrar user_type sempre que estiver presente (mesmo sem user_id)
    return true;
  });

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      marginTop: '16px',
      alignItems: 'center'
    }}>
      <span style={{
        fontSize: '14px',
        fontWeight: '600',
        color: '#6c757d',
        marginRight: '4px'
      }}>
        <Icon icon="mdi:filter" style={{ marginRight: '4px', fontSize: '16px' }} />
        Filtros ativos:
      </span>
      
      {activeFilters.map(([key, value]) => {
        // Mostrar user_type sempre que estiver presente (mesmo sem user_id)
        
        return (
          <Badge
            key={key}
            bg={getFilterColor(key)}
            style={{
              fontSize: '13px',
              padding: '6px 12px',
              borderRadius: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer'
            }}
            onClick={() => onRemoveFilter && onRemoveFilter(key)}
          >
            <span>{getFilterLabel(key, value)}</span>
            <Icon 
              icon="mdi:close" 
              style={{ 
                fontSize: '14px',
                cursor: 'pointer'
              }}
              onClick={(e) => {
                e.stopPropagation();
                onRemoveFilter && onRemoveFilter(key);
              }}
            />
          </Badge>
        );
      })}
    </div>
  );
};

export default ActiveFiltersTags;

